import './Loading.css';
import React from 'react';

class Loading extends React.Component {
    constructor(props) {
        super(props);
        const logoTemplate = document.querySelector("#PelCom-Emblem");
        this.logoSvg = logoTemplate.innerHTML;
        this.setLoadingElement();
    }

    setLoadingElement() {
        const styles = this.props?.style || {};
        this.loadingElement = (
            <p className="Loading-logo" style={styles} dangerouslySetInnerHTML={{ __html: this.logoSvg }}></p>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props?.style === prevProps?.style) {
            return;
        }
        this.setLoadingElement();
    }

    render() {
        return this.loadingElement;
    }
}

export default Loading;
